import { useEffect, useState } from "react";
import { isLinkVisible, navigationLinks } from "./Navigationbar";
import { useCurrUserUtility } from "../contexts/useCurrUserUtility";
import { AccountInfoModel } from "../generated/api";

export interface NavigationProps { }

const MobileNavigationbar = () => {
    const { isAuth, getCurrUser } = useCurrUserUtility();
    const [usr, setUsr] = useState<AccountInfoModel | undefined>(getCurrUser());

    useEffect(() => {
        setUsr(getCurrUser());
    }, [isAuth()]);

    const authenticated = isAuth();
    const userType = usr?.userType;

    // Same role/auth filtering as the desktop Navigationbar so the mobile menu
    // shows exactly the links the current user is allowed to see.
    const visibleLinks = navigationLinks.filter((item) =>
        isLinkVisible(item, authenticated, userType)
    );

    return (
        <div className="mobile-menu-items">
            <ul className="nav-menu">
                {visibleLinks.map((item, index) => {
                    const visibleSub = item.subMenu?.filter((sub) =>
                        isLinkVisible(sub, authenticated, userType)
                    );
                    return (
                        <li key={index}>
                            <a href={item.url}>{item.label}</a>
                            {visibleSub && visibleSub.length > 0 && (
                                <ul className="sub-menu">
                                    {visibleSub.map((subItem, subIndex) => (
                                        <li key={subIndex}>
                                            <a href={subItem.url}>{subItem.label}</a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default MobileNavigationbar;
